import { ApolloClient, HttpLink, InMemoryCache } from "@apollo/client";
import { GQL_URL } from "./lib/constant";

const clientFun = () => {
    const httpLink = new HttpLink({ uri: GQL_URL });
    return new ApolloClient({
        link: httpLink,
        cache: new InMemoryCache({addTypename: true}),
    });
}

export const client = clientFun()
